import './navigation-bar.css';

import EventEmitter from 'eventemitter3';
import { EventTypes } from '../../../core/event-bus';
import { LoyaltyProvider, Pages } from '../../../types/enums';
import { Util } from '../../../utils/util';
import { Data } from '../../../models/data';

export class NavigationBar {
    private readonly _eventBus: EventEmitter;
    private readonly _data: Data;
    private _routes: { id: string, location: Pages }[];

    constructor(eventBus: EventEmitter, data: Data) {
        this._eventBus = eventBus;
        this._data = data;
        this._routes = this._createRoutes();
    }

    private _createRoutes = (): { id: string, location: Pages }[] => {
        return [
            { id: "btn_nav_home", location: Pages.LANDING },
            { id: "btn_nav_rewards", location: Pages.REWARDS },
            { id: "btn_nav_favorites", location: Pages.FAVORITES },
            { id: "btn_nav_menu", location: Pages.MENU },
            { id: "btn_nav_orders", location: Pages.ORDERS }];
    }

    public init = (): void => {
        this._eventBusListeners();
        this._setEventListeners();

        if (Util.isAppView()) {
            Util.showElement("div_bottom_nav");
        } else {
            Util.hideElement("div_bottom_nav");
        }
    }

    private readonly _eventBusListeners = () => {
        this._eventBus.on(EventTypes.LOCATION_CHANGE, (location: Pages) => {
            const route = this._routes.find(x => x.location == location);
            this._routeChange(route?.id || "", location);
            this._onLocationChange(location);
        });

        this._eventBus.on(EventTypes.BRAND_DATA_RETRIEVED, () => {
            if (this._data.getLoyaltyInfo().providerId == LoyaltyProvider.NONE) {
                const rewards = document.getElementById("btn_nav_rewards");
                rewards && (rewards.style.display = "none");
            }
        });
    }

    private readonly _onLocationChange = async (page: Pages) => {
        const skipPages = [Pages.TRACK_ORDER, Pages.CHECKOUT, Pages.CART];
        const mobileBaseButtons = document.querySelectorAll(".common-base-button-mobile");

        if (skipPages.includes(page)) {
            Util.hideElement("div_bottom_nav");
            mobileBaseButtons.forEach(button => button.classList.add("regular-position"));
            return;
        }

        if (Util.isAppView()) {
            Util.showElement("div_bottom_nav");
            mobileBaseButtons.forEach(button => button.classList.remove("regular-position"));
        }
    }

    private readonly _setEventListeners = (): void => {
        for (const route of this._routes) {
            Util.setElement("onclick", route.id, () => {
                this._routeChange(route.id, route.location);
                this._eventBus.emit(EventTypes.LOCATION_CHANGE, route.location)
            });
        }
    }

    private readonly _routeChange = (id: string, location: Pages): void => {
        this._setActiveSelection(id);
        this._showComponent(location);
    }

    private _showComponent(id: string): void {
        const divs = Array.from(document.getElementsByClassName("content-component")) as HTMLElement[];
        for (const div of divs) {
            if (div.id == `div_main_${id.replace("/", "")}`)
                div.classList.add("active");
            else
                div.classList.remove("active");
        }
    }

    private readonly _setActiveSelection = (id: string): void => {
        const navItems = Array.from(document.querySelectorAll(".nav-item"));
        for (const item of navItems) {
            if (item.id == id)
                item.classList.add("active");
            else
                item.classList.remove("active");
        }
    }
}